<template>
  <div style="background-color: #00a8bb; height: 850px; overflow: hidden">
    <div id="app">
      <ul id="menu" style="background-color: #000"></ul>
      <v-container fluid grid-list-md fill-height style="padding: 3%">
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 style="text-align: center">
            <div class="direita">
              <a
                href="http://enercred.com.br"
                target="_blank"
                alt="Juntos Energia Compartilhada"
                ><img
                  src="/img/newJuntos_logo_white.png"
                  style="padding: 5px"
                  alt=""
                  class="src"
              /></a>
              <img
                src="../assets/fundo.png"
                width="110%"
                class="hidden-sm-and-down"
              />
            </div>
          </v-flex>
          <v-flex d-flex xs12 sm12 md6 flex justify-center>
            <div class="form_cad">
              <div class="form_login">
                <div
                  class="display-1"
                  style="padding-bottom: 40px; color: #808080"
                >
                  REINICIAR SENHA
                </div>
                <div style="color: #808080">
                  Insira e confirme sua nova senha.
                </div>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="newPassword"
                    name="newPassword"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :rules="newPasswordRules"
                    hint="Mínimo de 8 caracteres"
                    label="Nova senha"
                    :type="show1 ? 'text' : 'password'"
                    prepend-icon="fingerprint"
                    @click:append="show1 = !show1"
                    @keyup.enter="validate"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="newPasswordConfirm"
                    name="newPasswordConfirm"
                    :rules="newPasswordConfirmRules"
                    hint="Deve coincidir com a nova senha"
                    label="Confirmar senha"
                    type="password"
                    prepend-icon="fingerprint"
                    @keyup.enter="validate"
                    required
                  ></v-text-field>
                  <div class="errorMsg" v-if="errorMsg !== ''">
                    {{ errorMsg }}
                  </div>
                  <v-layout align-center justify-space-around row>
                    <router-link :to="{ name: 'login' }" replace
                      >Lembei a senha</router-link
                    >
                    <div v-if="!done">
                      <v-btn
                        :loading="loading"
                        @click="validate"
                        :disabled="!valid || loading"
                        color="success"
                        flat
                        large
                        >CONFIRMAR
                      </v-btn>
                    </div>
                    <div v-else>
                      Senha alterada com sucesso! Você pode agora usar suas
                      novas credenciais na tela de login.
                    </div>
                  </v-layout>
                </v-form>
              </div>
            </div>
          </v-flex>
          <v-snackbar
            :color="color"
            :bottom="bottom"
            :top="top"
            :left="left"
            :right="right"
            v-model="snackbar"
            dark
          >
            <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
            <div>{{ snackMessage }}</div>
            <v-icon size="16" @click="snackbar = true">
              mdi-close-circle
            </v-icon>
          </v-snackbar>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { firebaseAuth } from "../firebase/firebaseAuth";

export default {
  data: () => ({
    valid: false,
    show1: false,
    loader: null,
    loading: false,
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackMessage: "",
    snackbar: false,
    errorMsg: "",
    newPassword: "",
    newPasswordConfirm: "",
    newPasswordRules: [
      (v) => !!v || "Por favor, informe sua nova senha",
      (v) =>
        v.length >= 8 ||
        "Por favor, sua nova senha deve conter no mínimo 8 caracteres.",
    ],
    done: false,
  }),

  methods: {
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        await this.NovaSenha();
      }
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    NovaSenha: function () {
      if (!this.$route.query.oobCode) {
        this.snack("Código indentificador não definido.", "error", "top");
        return;
      }
      firebaseAuth
        .confirmPasswordReset(this.$route.query.oobCode, this.newPassword)
        .then(() => {
          this.loading = false;
          this.done = true;
        })
        .catch((error) => {
          console.error("Error: ", error);
          this.loading = false;
          firebaseAuth.signOut();
          if (error.code === "auth/wrong-newPassword") {
            this.snack("Ops! Senha inválida.", "error", "top");
          } else if (error.code === "auth/user-not-found") {
            this.snack(
              "Ops! Email não encontrado em nossa base, tem certeza que se cadastrou com esse e-mail?",
              "error",
              "top",
            );
          } else if (error.code === "auth/user-disabled") {
            this.snack(
              "Ops! Usuário correspondente foi desativado.",
              "error",
              "top",
            );
          } else {
            this.snack(
              "Ops! " + error.code + ": " + error.message,
              "error",
              "top",
            );
          }
        });
    },
  },
  computed: {
    newPasswordConfirmRules() {
      return [
        () =>
          this.newPassword === this.newPasswordConfirm ||
          "Campos não coincidem.",
      ];
    },
  },
};
</script>

<style scoped>
html,
body {
  height: 100%;
}
.form_cad {
  height: 100%;
  vertical-align: -webkit-baseline-middle;
  vertical-align: middle;
  padding-left: 5%;
  padding-top: 20%;
  text-align: center;
  width: 60%;
}
.form_login {
  width: 95%;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
}
.direita {
  width: 90%;
  padding-left: 5%;
  padding-top: 10%;
  text-align: left;
}
.login {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
p a {
  text-decoration: underline;
  cursor: pointer;
}
.social-button {
  width: 75px;
  background: white;
  padding: 10px;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  outline: 0;
  border: 0;
}
.social-button:active {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}
.social-button img {
  width: 100%;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.errorMsg {
  color: red;
}
</style>
